/**
 * Auto-fill Settings Utilities
 * Manage auto-fill feature toggles for attendance functionality
 */

/**
 * Check if auto-fill is enabled (master toggle)
 * @returns {boolean} True if enabled, false if disabled
 */
export const isAutoFillEnabled = () => {
  try {
    const setting = localStorage.getItem('arcattend_autofill_enabled');
    return setting !== 'false'; // Default to true if not set
  } catch (error) {
    console.warn('Failed to read auto-fill enabled setting:', error);
    return true; // Default to enabled
  }
};

/**
 * Set the main auto-fill enabled setting
 * @param {boolean} enabled - Whether to enable or disable the feature
 */
export const setAutoFillEnabled = (enabled) => {
  try {
    localStorage.setItem('arcattend_autofill_enabled', enabled.toString());
  } catch (error) {
    console.warn('Failed to save auto-fill enabled setting:', error);
  }
};

/**
 * Check if auto-fill from drafts is enabled
 * @returns {boolean} True if enabled, false if disabled
 */
export const isAutoFillFromDraftsEnabled = () => {
  try {
    const setting = localStorage.getItem('arcattend_autofill_drafts');
    return setting !== 'false'; // Default to true if not set
  } catch (error) {
    console.warn('Failed to read auto-fill drafts setting:', error);
    return true; // Default to enabled
  }
};

/**
 * Check if auto-fill from database is enabled
 * @returns {boolean} True if enabled, false if disabled
 */
export const isAutoFillFromDatabaseEnabled = () => {
  try {
    const setting = localStorage.getItem('arcattend_autofill_database');
    return setting !== 'false'; // Default to true if not set
  } catch (error) {
    console.warn('Failed to read auto-fill database setting:', error);
    return true; // Default to enabled
  }
};

/**
 * Set the auto-fill from drafts setting
 * @param {boolean} enabled - Whether to enable or disable the feature
 */
export const setAutoFillFromDrafts = (enabled) => {
  try {
    localStorage.setItem('arcattend_autofill_drafts', enabled.toString());
  } catch (error) {
    console.warn('Failed to save auto-fill drafts setting:', error);
  }
};

/**
 * Set the auto-fill from database setting
 * @param {boolean} enabled - Whether to enable or disable the feature
 */
export const setAutoFillFromDatabase = (enabled) => {
  try {
    localStorage.setItem('arcattend_autofill_database', enabled.toString());
  } catch (error) {
    console.warn('Failed to save auto-fill database setting:', error);
  }
};

/**
 * Get all auto-fill settings
 * @returns {object} Object containing all auto-fill settings
 */
export const getAutoFillSettings = () => {
  return {
    enabled: isAutoFillEnabled(),
    draftsEnabled: isAutoFillFromDraftsEnabled(),
    databaseEnabled: isAutoFillFromDatabaseEnabled()
  };
};
